/**
 * --------------------------------------------------------------------------
 * Basic Modules: SearchPopover.js
 * --------------------------------------------------------------------------
 */

//import Util from "./util";

/**
 * ------------------------------------------------------------------------
 * Constants
 * ------------------------------------------------------------------------
 */

const DEBUG             = false;
const NAME              = 'searchPopover';
const DATA_KEY          = NAME;
const EVENT_KEY         = `.${DATA_KEY}`;
const LOG_KEY           = `[${NAME}]`;

const Default = {};

const Event = {
    RESIZE              : `resize${EVENT_KEY} orientationchange${EVENT_KEY}`,
    SCROLL              : `scroll${EVENT_KEY}`,
    CLICK               : `click${EVENT_KEY}`,
};

const ClassName = {
    SHOW                : 'show',
};

const Selector = {
    TOGGLE              : `[data-toggle="${NAME}"]`,
    SEARCH_TOGGLE       : '.js-header-search-toggle',
    SEARCH_POPOVER      : '.js-header-search-popover',
    SEARCH_SUBMIT       : 'button',
    SEARCH_FORM         : 'form',
};

const DataAttr = {
};

class SearchPopover {

    constructor(element, config) {

        DEBUG && console.log(LOG_KEY, 'Init');

        this._element = element;
        this._config  = this._getConfig(config);

        this._toggle        = document.querySelector(Selector.SEARCH_TOGGLE);
        this._searchPopOver = this._element.querySelector(Selector.SEARCH_POPOVER);
        this._searchSubmit  = this._element.querySelector(Selector.SEARCH_SUBMIT);
        this._searchForm    = this._element.querySelector(Selector.SEARCH_FORM);

        this._addEventListeners();

        this._setupValidation();
    }

    destroy() {
        $(this._element).off(EVENT_KEY);
        $.removeData(this._element, DATA_KEY);
        this._element = null;
    }

    // Private

    _setupValidation() {
        $(this._searchForm).validate({
            rules: {
                q: {
                    required: true
                }
            },
            highlight: function(element) {
                $(element)
                    .closest('.control-group')
                    .removeClass('success')
                    .addClass('error')
            },
            success: function(element) {
                $(element)
                    .closest('control-group')
                    .removeClass('error')
                    .addClass('success')
            }
        });
    }

    _handleSearchClose(event) {
        if ($(event.target).closest($(this._element)).length === 0) {
            this._searchPopOver.classList.remove(ClassName.SHOW);
        }
    }

    _handleSearchToggle(event) {
        event.preventDefault();
        this._searchPopOver.classList.add(ClassName.SHOW);

        setTimeout(() => {
            $(this._searchPopOver).find('input').focus();
        }, 250);
    }

    _handleFormSubmission(event) {
        $(this._searchForm).submit();
    }

    _getConfig(config) {
        return {
            ...Default,
            ...config
        };
    }

    _addEventListeners() {
        $(document).on(Event.CLICK, (event) => this._handleSearchClose(event));
        $(this._toggle).on(Event.CLICK, (event) => this._handleSearchToggle(event));
        $(this._searchSubmit).on(Event.CLICK, (event) => this._handleFormSubmission(event))
    }

    // Static

    /**
     * Convenient static method to initiate the module.
     *
     * @param config
     * @param selector
     */
    static bind (config, selector) {
        SearchPopover._jQueryInterface.call($(selector || Selector.TOGGLE), config);
    }

    /**
     * jQuery Interface
     * @param config
     * @returns {*}
     */
    static _jQueryInterface(config) {
        return this.each(function() {
            const $this = $(this);
            let data    = $this.data(DATA_KEY);
            let _config = {
                ...Default,
                ...$this.data(),
                ...typeof config === 'object' && config ? config : {}
            };

            if (!data) {
                data = new SearchPopover(this, _config);
                $this.data(DATA_KEY, data);
            }

            if (typeof config === 'string') {
                if (typeof data[config] === 'undefined') {
                    throw new TypeError(`No method named "${config}"`);
                }
                data[config]();
            }
        });
    }
}

/**
 * ------------------------------------------------------------------------
 * jQuery
 * ------------------------------------------------------------------------
 */

$.fn[NAME] = SearchPopover._jQueryInterface;
$.fn[NAME].Constructor = SearchPopover;


export default SearchPopover;
